import { get } from 'lodash';
import React from 'react';
import { FORM_WIDGET_COMPONENTS } from '../../../form/formConstants';
import FormWidget from '../../../form/FormWidget';
import { useI18n } from '../../../i18n/I18n';
import { Icons } from '../../../icons/Icons';
import { H } from '../../../Layout';
import { SCHEDULE_FORM_WIDGET_FIELD_NAMES } from '../constants';
import useScheduleFormWidgetContext from '../useScheduleFormWidgetContext';
import { resolveStateFieldName } from '../utils/form-utils';

export interface ScheduleLocationFormWidgetProps {
    name?: string;
    disabled?: boolean;
}

export default function ScheduleLocationFormWidget({
    name: nameProp,
    disabled: disabledProp = false
}: ScheduleLocationFormWidgetProps) {
    const t = useI18n();

    const { loading, disabled, error, allowedLocations, allowAdditionalLocations } = useScheduleFormWidgetContext();

    const name = resolveStateFieldName([nameProp, SCHEDULE_FORM_WIDGET_FIELD_NAMES.LOCATION]);

    const isWidgetDisabled = disabled || disabledProp || loading;

    const widgetErrors = get(error, name);

    return (
        <H sx={{ alignItems: 'center', gap: 1 }}>
            <Icons.PlaceIcon color={isWidgetDisabled ? 'disabled' : 'action'} />
            <FormWidget
                component={FORM_WIDGET_COMPONENTS.location}
                name={name}
                label={t('scheduleFormWidget.location.label')}
                appendTimeZone={true}
                defaultOptions={allowedLocations}
                allowAdditionalLocations={Boolean(allowedLocations) ? allowAdditionalLocations : undefined}
                disabled={isWidgetDisabled}
                hasErrors={Boolean(widgetErrors)}
                errors={widgetErrors}
            />
        </H>
    );
}
